import React from 'react';
import { Box, Group, Flex } from '@landr/maestro';
import { cva } from '../../../../styled-system/css/cva';

const actionsStyles = cva({
    base: {
        display: 'flex',
        alignItems: 'flex-end',
        paddingTop: { base: 'sm', md: 'xl' },
        md: {
            _last: {
                paddingBottom: 'none',
            },
        },
    },

    variants: {
        isBottomAligned: {
            true: {
                flexGrow: 10,
                alignContent: 'end',
            },
        },
    },
    defaultVariants: {
        isBottomAligned: false,
    },
});

const Actions: React.FC<{
    actions: JSX.Element[];
    isBottomAligned?: boolean;
}> = ({ actions, isBottomAligned = false }) => (
    <Box
        className={actionsStyles({ isBottomAligned })}
        justifyContent={{ base: 'center', md: 'flex-start' }}
        marginBottom={{ base: 'jb', md: 0 }}
    >
        {!!actions.length && (
            <Flex
                flexDirection="row"
                justifyContent={{ base: 'center', md: 'left' }}
            >
                {actions.length && (
                    <Group.Item>
                        <Group gap="xs">
                            {actions.map((action) => (
                                <Group.Item key={action.key}>
                                    {action}
                                </Group.Item>
                            ))}
                        </Group>
                    </Group.Item>
                )}
            </Flex>
        )}
    </Box>
);

Actions.displayName = 'PageHeader.Actions';

export default Actions;
